import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  min-height: 100%;
  display: flex;
  flex-direction: column;

  ${({ theme }) => css`
    padding-top: ${theme.padding.small};
  `}
`;

export const BottomBarContainer = styled.div`
  height: 128px;
  left: 0;
  bottom: 0;
  right: 10px;
  position: absolute;
  z-index: 100;
  background-color: rgba(7, 8, 6, 0.85);
  backdrop-filter: blur(10px);

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  button {
    width: 152px;
  }

  ${({ theme }) => css`
    padding: 0 ${theme.padding.biggest};

    .group-btns-container {
      display: flex;
      flex-direction: row;
      gap: ${theme.padding.default};
    }
  `}
`;
